import React from 'react';
import { gameStateManager } from '../../App';
import { utils } from '../../utils';
import { useEffect, useState } from "react";
import PixiAnimatedContainer, { EASING } from './PixiAnimatedContainer';
import { Text, Sprite } from '@pixi/react';
import { pixiGameUtils } from '../PixiGame/PixiGameUtils'
import { boardTileSize } from '../../env';

const PixiOnFeatureScoredHandler = ( { endGamePhaseAnimDelay } ) =>
{
  const [ scoredFeatureDatas, setScoredFeatureDatas ] = useState( [] );
  const [ renderScale, setRenderScale ] = useState( 1.0 );

  useEffect( () =>
  {
    let onMeepleReturnAnimationRequest = ( data ) =>
    {
      // meepleDatas:[
      //  { isFarmer: false,
      //    localMeepleCoords: {x: 0, y: 0.32},
      //    tileHash: "130304"
      //  }
      // ]
      // playerColourHex: "#2b6fc1"
      // playerColourID: "blue"
      // pointsScored: 4,
      // featureType: 0

      if( data.meepleDatas )
      {
        for( let idx = 0; idx < data.meepleDatas.length; idx++ )
        {
          if( data.pointsScored <= 0 )
          {
            continue;
          }

          let meepleData = data.meepleDatas[ idx ];
          let tileCoord = utils.hashToCoord( meepleData.tileHash );
          const newScoredFeatureData =
          {
            isFarmer: meepleData.isFarmer,
            localMeepleCoords: meepleData.localMeepleCoords,
            tileCoords: tileCoord,
            playerColourHex: data.playerColourHex,
            playerColourID: data.playerColourID,
            points: data.pointsScored,
            featureType: data.featureType
          };

          // console.log( `Adding newReturningMeepleData: `, newReturningMeepleData );

          setScoredFeatureDatas( prev => [ ...prev, newScoredFeatureData ] );

          break;
        }
      }
    };

    let onStageRenderDataChanged = ( stageRenderData ) =>
    {
      setRenderScale( stageRenderData.scale );
    };

    gameStateManager.addOnMeepleReturnAnimationRequestCallback( onMeepleReturnAnimationRequest );

    let currentStageRenderData = gameStateManager.addOnStageRenderDataChangeCallback( onStageRenderDataChanged );
    setRenderScale( currentStageRenderData.scale );

    return () =>
    {
      gameStateManager.removeOnMeepleReturnAnimationRequestCallback( onMeepleReturnAnimationRequest );
      gameStateManager.removeOnStageRenderDataChangeCallback( onStageRenderDataChanged );
    };
  }, [] ); // Empty dependency array means "run once"


  // console.log( "RENDER RETURNING MEEPS ANIMS" );

  let meepleElements = [];

  for( let idx = 0; idx < scoredFeatureDatas.length; idx++ )
  {
    let scoredFeatureData = scoredFeatureDatas[ idx ];
    let tileCoords = scoredFeatureData.tileCoords;
    let localMeepleCoords = scoredFeatureData.localMeepleCoords;
    let points = scoredFeatureData.points;
    let featureType = scoredFeatureData.featureType;

    meepleElements.push(
      <PixiAnimatedContainer
        key={ `scoredFeature_${tileCoords.x}_${tileCoords.y}` }
        animSteps={
          [
            {
              fromOffsetX: 0,
              fromOffsetY: -20,
              fromAngle: -360,
              fromAlpha: 0,
              fromScale: 0,
              toOffsetX: 0,
              toOffsetY: -170,
              toAngle: 0,
              toAlpha: 1,
              toScale: 1,
              duration: 700,  // ms
              easing: EASING.IN_OUT_BACK
            },
            {
              fromOffsetX: 0,
              fromOffsetY: -170,
              fromAlpha: 1,
              toOffsetX: 0,
              toOffsetY: -310,
              toAlpha: 0,
              duration: 2000,  // ms
              easing: EASING.IN_OUT_SINE
            }
          ]
        }
        delay={ gameStateManager.isInEndGamePhaseState() ? endGamePhaseAnimDelay : 0 }
        onAnimFinish={ () =>
        {
          // Remove this entry from the state array to stop it re-rendering
          setScoredFeatureDatas( prev => prev.filter( mData => mData !== scoredFeatureData ) );
        } }
        renderScale={ renderScale }
        x={ ( tileCoords.x + localMeepleCoords.x ) * boardTileSize }
        y={ ( -1 * ( tileCoords.y + localMeepleCoords.y ) ) * boardTileSize }
        anchor={ { x: 0.5, y: 0.5 } }
      >

        <Sprite
          image={ `./ui/panel_bg.png` }
          scale={ renderScale }
          x={ -30 * renderScale }
          y={ 0 }
          width={ 50 * renderScale }
          height={ 50 * renderScale }
          anchor={ 0.5 }
        />

        <Sprite
          image={ pixiGameUtils.featureTypeValueToImgURL_128x128( featureType ) }
          scale={ renderScale * 0.35 }
          x={ -30 * renderScale }
          y={ 0 }
          anchor={ 0.5 }
        />

        <Text
          key={ `scoredFeature_${tileCoords.x}_${tileCoords.y}_score_text` }
          text={ points.toString() }
          x={ 0 }
          y={ 0 }
          anchor={ { x: 0, y: 0.5 } }
          style={ {
            fontSize: 50 * renderScale,
            fontWeight: "bold",

            fill: 'white',
            stroke: 'black',
            strokeThickness: 6,
          } }
        />
      </PixiAnimatedContainer> );
  }

  return (
    <>
      { meepleElements }
    </>
  );
}

export default React.memo( PixiOnFeatureScoredHandler,
  ( prevProps, nextProps ) =>
  {
    // NOTE: We never want this component to be re-rendered because the parent component is re-rendering.
    return true;
  }
);
